import gql from 'graphql-tag'
import xaxios from '@/xaxios'

export const getMeses = () => {
    const meses = [];
    meses.push({id:1,text:'enero'});
    meses.push({id:2,text:'febrero'});
    meses.push({id:3,text:'marzo'});
    meses.push({id:4,text:'abril'});
    meses.push({id:5,text:'mayo'});
    meses.push({id:6,text:'junio'});
    meses.push({id:7,text:'julio'});
    meses.push({id:8,text:'agosto'});
    meses.push({id:9,text:'septiembre'});
    meses.push({id:10,text:'octubre'});
    meses.push({id:11,text:'noviembre'});
    meses.push({id:12,text:'diciembre'});
    const mesactual = new Date().getMonth();
    return {meses:meses, actual:meses[mesactual]};
}

export const getGestiones = async (vue) => {
    const gestiones = [];
    let sql = gql`query{ getGestiones{ gestion } }`;
    let res = await vue.$apollo.query({ query: sql }).then(({ data }) => data);
    res.getGestiones.reverse().forEach(g=>{
        gestiones.push({id:g.gestion,text:g.gestion})
    })
    let anioactual = new Date().getFullYear()
    anioactual = gestiones.find(x=>x.id == anioactual);
    return {gestiones:gestiones, actual: anioactual};
}

export const getSedes = async (vue) => {
    let sql = gql`query{ getSedes{ id,nombre } }`;
    let res = await vue.$apollo.query({ query: sql }).then(({ data }) => data);
    const idactual = vue.$store.state.CARGO.sede.id;
    const sedes = [];
    res.getSedes.forEach(x=>{
        sedes.push({id:x.id, text:x.nombre});
    })
    const actual = sedes.find(x=>x.id==idactual)
    return {sedes:sedes, actual: actual};
}

export const getDatos = async (url) => {
    const res = await xaxios.get(url).then(({data})=>data);
    const datos = res.data;
    datos.forEach((x,i)=>x.xid=i)
    return datos;
}